<template>
    <b-card :class="widgetClass" :header="widget.title">
        {{ widget.description }}
    </b-card>
</template>

<script>
import safeEval from 'safe-eval'

export default {
    props: {
        widget: {
            type: Object
        }
    },
    data: function() {
        return {
            models: null
        }
    },
    computed: {
        widgetClass() {
            if (this.widget.variant != "" && this.widget.variant != "light") {
                 return "text-white " + "bg-" + this.widget.variant
            }
        }
    },

    created() {}
}
</script>